module.exports = __webpack_public_path__ + "img/10pasteis.1827e03f.svg";